// components/Comments.jsx
import React, { useState } from "react";
import {
  List,
  Card,
  Avatar,
  Input,
  Button,
  Form,
  Space,
  message,
  Divider,
} from "antd";
import { UserOutlined, MessageOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const Comments = ({ comments, onSubmit }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await onSubmit(values);
      form.resetFields();
      message.success("评论发表成功！");
    } catch (error) {
      message.error("评论发表失败，请重试");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card title={`评论 (${comments.length})`} bordered={false}>
      <List
        itemLayout="horizontal"
        dataSource={comments}
        renderItem={(comment) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar icon={<UserOutlined />} />}
              title={comment.author}
              description={
                <div>
                  <div>{new Date(comment.createdAt).toLocaleString()}</div>
                  <div style={{ marginTop: 8 }}>{comment.content}</div>
                </div>
              }
            />
          </List.Item>
        )}
      />

      <Divider />

      <Form form={form} onFinish={handleSubmit}>
        <Form.Item
          name="content"
          rules={[{ required: true, message: "请输入评论内容" }]}
        >
          <TextArea rows={4} placeholder="写下您的评论..." />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={submitting}>
              <MessageOutlined /> 发表评论
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Comments;
